import React from "react";

function LabelIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_899_1339)">
        <mask
          id="mask0_899_1339"
          style={{ maskType: "luminance" }}
          width="16"
          height="16"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M0 0h16v16H0V0z"></path>
        </mask>
        <g mask="url(#mask0_899_1339)">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M7.511 3.577c-.266-.294-.741-.294-1.035 0l-3.22 3.166c-.265.32-.74.32-1.034 0-.293-.266-.293-.741 0-1.035l3.193-3.193c.88-.88 2.306-.88 3.185 0l4.473 4.475-5.893 5.898a10.756 10.756 0 01-5.5 2.94l-.782.157a.702.702 0 01-.678-.231.678.678 0 01-.205-.651l.156-.782a10.762 10.762 0 012.943-5.5l4.835-4.834-.438-.41zm7.902-1.757c.782.782.782 2.051 0 2.833l-1.63 1.63-4.066-4.066 1.63-1.63a2.005 2.005 0 012.834 0l1.232 1.233z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_899_1339">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(LabelIcon);
